function fn_part_aside_sort() {
    var main_nav = $("#main-nav .nav");
    var main_nav_header = $("#main-header .nav");
    var main_nav_html = main_nav.html();
    $(document).on('click', '#main-nav .icon-alphabetically, #main-header .icon-alphabetically', function (e) {
        e.preventDefault();
        var li = main_nav.children("li");
        var alphabetically = li.sort(function (a, b) {
            var _a = $(a).find("a > i").text();
            var _b = $(b).find("a > i").text();
            return (_a < _b) ? -1 : (_a > _b) ? 1 : 0;
        });
        $(this).parents("nav").find(".nav").html(alphabetically);
        if ($(this).hasClass("active")) {
            main_nav.html(main_nav_html);
            main_nav_header.html(main_nav_html);
        }
        $(this).toggleClass("active");
    });

    $(document).on('click', '#main-nav .toggle', function () {
        $(this).find(".icon").toggleClass("active").parent().next(".nav").stop(true).slideToggle(500).toggleClass("active");
        $("#bgp").fadeToggle(500);
    });

    $(document).on('click', '#bgp', function () {
        $("#bgp").fadeToggle(500);
        $("#main-nav .toggle").find(".icon").toggleClass("active").parent().next(".nav").stop(true).slideToggle(500).toggleClass("active");
    });
}
